import React, { useEffect, useState } from 'react';
import image from '../images/logo.png';
import Mainmenu from './Mainmenu'
import LoadingDots from './LoadingDots'
import bot from '../images/happy.png'

function Greetings() {
    const [time] = useState(new Date());

    const getGreeting = () => {
        const hours = time.getHours();
        if (hours < 12) return "Good Morning";
        if (hours < 18) return "Good Afternoon";
        return "Good Evening";
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => setLoading(false), 1000);
    }, []);

    return (
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>

        <div className="frame1 animated-frame">
           
                {getGreeting()}, Greetings from Akaay Feeds<br />
            
        </div>
         <div className="frame1 animated-frame">
        
         Akaay Feeds is an innovation-driven leader in the animal nutrition industry, 
         embodying the philosophy of 'Think Global - Act Local' to revolutionize the livestock 
         and poultry feed sector with high-quality, sustainable, and science-backed solutions.
         
     </div>
      <Mainmenu />
     </>
    );
}

export default Greetings;
